<template>
  <div class="hotel_calendar--footer">
        <span class="footer--legend">
          <span class="legend--item legend--item-special_offer"> Special<span class="mobile-hidden"> Offer</span></span>
          <span class="legend--item legend--item-day_highlight"><span class="mobile-hidden"> Date</span> Selected</span>
        </span>
    <a v-on:click.prevent="closeCalendar" title="Click to close the calendar" class="footer--close"
       href="#">Close</a>
  </div>
</template>

<script lang="ts">
/*!
 * Copyright (C) 2024, Peppermill Inc.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are not permitted.
 *//*
 *		2024-05-17 (jhoward)
 *			- Refactor calendar footer from hotelCalendar.vue to hotelCalendarFooter.vue.
 */

import {defineComponent} from 'vue'

export default defineComponent({
  name: "hotelCalendarFooter",
  emits: ['close'],
  methods: {
    closeCalendar() {
      this.$emit('close');
    },
  }
})
</script>

<style scoped>
.hotel_calendar--footer {
  bottom: 12px;
  height: 24px;
  left: 12px;
  position: absolute;
  right: 12px;
}

.footer--close {
  float: right;
}

.legend--item {
  display: none;
  position: relative;
}

.legend--item + .legend--item {
  margin-left: 2em;
}

.calendar--container.show-special-offers .hotel_calendar--footer .legend--item {
  display: inline-block;
}

.legend--item::before {
  content: '';
  display: inline-block;
  height: 1.5em;
  margin-right: 0.25em;
  position: relative;
  vertical-align: middle;
  width: 1.5em;
  margin-top: -0.25em;
}

.legend--item-special_offer:before {
  background: linear-gradient(to bottom, rgba(213, 34, 40, 1) 15%, rgba(158, 158, 158, 1) 15%, rgba(158, 158, 158, 1) 100%);
}

.legend--item-day_highlight::before {
  background-color: #007966;
  background-color: rgba(0, 121, 102, 1);
}
</style>